(function ($) {
    function getPadding(el, name) {
        var torl = name == 'height' ? 'Top' : 'Left',  // top or left
            borr = name == 'height' ? 'Bottom' : 'Right'; // bottom or right

        return (
        // we add "0" to each string to make sure parseInt() returns a number
            parseInt("0" + $.curCSS(el, "border" + torl + "Width", true), 10)
            + parseInt("0" + $.curCSS(el, "border" + borr + "Width", true), 10)
            + parseInt("0" + $.curCSS(el, "padding" + torl, true), 10)
            + parseInt("0" + $.curCSS(el, "padding" + borr, true), 10)
            + parseInt("0" + $.curCSS(el, "margin" + torl, true), 10)
            + parseInt("0" + $.curCSS(el, "margin" + borr, true), 10)
        );
    };
    $.fn.extend({
      resetMcDropdown: function (menuId) {
        if ($(this).parent().is('.mcdropdown')) {
          var generatedElement = $(this).parent().parent();
          $(this).appendTo(generatedElement.parent());
          generatedElement.remove();
          $(this).removeData('mcDropdown');
          $(this).attr('type', 'text');
          $(menuId).removeData('width').removeData('dimensions').find('li').removeAttr('style');
        }
      },
    multiSelect: function(itemValue, itemText, options) {

      var defaults = {
        buttonClass: "ui-state-default ui-icon ui-icon-trash",
        selectedItems: "selectedItems",
        selectedDelimiter: "|",
        targetName: "multiSelect",
        canDelete: "True"
      };

      var defaults = $.extend({ }, defaults, options);

      $multi = this;

      $multi.addClass("MultiSelectAutoScroll");
      $multi.attr("autoScrollFF", "FF");

      var selectedItems = $multi.attr(defaults.selectedItems);
      var existing = false;
      var listID = $multi.attr(defaults.targetName);

      if (selectedItems != undefined) {
        existing = selectedItems.indexOf(itemValue + defaults.selectedDelimiter) > -1;
      }
      if (itemText != undefined && itemValue != undefined) {
        if (itemText.length > 0 && !existing) {

          var liId = "li" + $multi.attr('id') + itemValue;

          var li = $(document.createElement("li"))
            .attr({ id: liId })
            .appendTo($multi);

          var label = $(document.createElement("label"))
            .html(itemText)
            .appendTo(li);
          if (defaults.canDelete == "True") {
            var button = $(document.createElement("button"))
              .addClass(defaults.buttonClass)
              .appendTo(li)
              .click(function() { $.fn.multiSelect.removeSelection.call($(this).parent(), listID, itemValue); });
          }
          var hiddeninput = $(document.createElement("input"))
            .attr({ name: defaults.targetName, type: "hidden" })
            .val(itemValue)
            .appendTo(li);

          var listOfSelected = this.attr(defaults.selectedItems);
          if (listOfSelected == undefined) {
            listOfSelected = "";
          }
          listOfSelected = listOfSelected + itemValue;
          if (listOfSelected.length > 0) {
            listOfSelected = listOfSelected + defaults.selectedDelimiter;
          }
          this.attr(defaults.selectedItems, listOfSelected);
        }
      }

      $.fn.multiSelect.removeSelection = function(itemId, itemValue) {
        if (itemId != undefined) {
          var id = "#" + itemId;
          $(id).remove();
        } else {
          $(this).remove();
        }
        var listOfSelected = $multi.attr(defaults.selectedItems);
        itemId = itemValue + defaults.selectedDelimiter;
		      if (listOfSelected == undefined) {
			      listOfSelected = "";
		      }

		      listOfSelected = listOfSelected.replace(itemId, '');
        $multi.attr(defaults.selectedItems, listOfSelected);

        $multi.trigger('itemRemoved');
      },
      $.fn.multiSelect.getSelection = function() {
        var idStr = $multi.attr(defaults.selectedItems);
        if (idStr != undefined) {
          idStr = idStr.substr(0, idStr.length - defaults.selectedDelimiter.length);
          return idStr.split(defaults.selectedDelimiter);
        } else {
          return null;
        }
      };
    }    
  });
})(jQuery);

function setMultiSelection(values, target) {
    var splitValue = values.split("|");
    $.each(splitValue, function(id) {
      var itemVal = splitValue[id];
      $("#" + target).mcDropdown().setValue(itemVal);
    });
  }

  function applyDisabledItems(combo, e, dropdown, settings) {
    var $this = $(combo);
    if ($this.is('.mcDisabled')) return false;
    if ($this.attr(settings.valueAttr)) {
      dropdown.setValue($this.attr(settings.valueAttr));
    } else {
      dropdown.setValue($($this.parents("li")[0]).attr(settings.valueAttr));
    }
    return true;
  }
